import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, Tab, Box } from '@mui/material';

// Flag emojis for languages
const FLAGS = {
  de: '🇩🇪',
  en: '🇺🇸'
};

const LanguageSelector: React.FC = () => {
  const { i18n, t } = useTranslation();

  const handleLanguageChange = (event: React.SyntheticEvent, newValue: string) => {
    i18n.changeLanguage(newValue);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Tabs
          value={i18n.language}
          onChange={handleLanguageChange}
          sx={{
            minHeight: 'auto',
            width: '100%',
            '& .MuiTabs-indicator': {
              backgroundColor: 'primary.main',
            },
            '& .MuiTab-root': {
              minHeight: 'auto',
              padding: '6px 12px',
              fontSize: '0.75rem',
              textTransform: 'none',
              color: 'text.secondary',
              opacity: 0.7,
              flex: 1,
              '&.Mui-selected': {
                opacity: 1,
                fontWeight: 'bold',
                color: 'primary.main',
                backgroundColor: 'rgba(25, 118, 210, 0.08)',
              },
              '&:hover': {
                opacity: 0.9,
                color: 'primary.main',
                backgroundColor: 'rgba(25, 118, 210, 0.04)',
              },
            },
          }}
        >
          <Tab
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, justifyContent: 'center' }}>
                <span style={{ fontSize: '1.2rem' }}>{FLAGS.de}</span>
                <span>DE</span>
              </Box>
            }
            value="de"
            aria-label={t('language.de')}
          />
          <Tab
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, justifyContent: 'center' }}>
                <span style={{ fontSize: '1.2rem' }}>{FLAGS.en}</span>
                <span>EN</span>
              </Box>
            }
            value="en"
            aria-label={t('language.en')}
          />
        </Tabs>
      </Box>
    </Box>
  );
};

export default LanguageSelector; 